(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[406],{

/***/ 17599:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[slug]",
      function () {
        return __webpack_require__(63298);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52009:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/placeholder-600x300.9a19c640.jpg","height":300,"width":600,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAXEAEBAQEAAAAAAAAAAAAAAAAAEQEi/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCt3mTABX//2Q==","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 49847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ CIconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64761);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49834);





var CIconButton = function(param) {
    var className = param.className, onClick = param.onClick, label = param.label, dark = param.dark, light = param.light, props = param.props;
    var colorScheme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .useMantineTheme */ .rZ)().colorScheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .ActionIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: className,
        onClick: onClick
    }, props), {
        children: [
            colorScheme === "dark" ? dark : light,
            label && label
        ]
    }));
};


/***/ }),

/***/ 83480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ CImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52009);







var CImage = function(props) {
    var src = props.src, fallbackSrc = props.fallbackSrc, alt = props.alt, onClick = props.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "src",
        "fallbackSrc",
        "alt",
        "onClick"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src), imgSrc = ref[0], setImgSrc = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setImgSrc(src);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        src: imgSrc,
        alt: alt,
        onLoadingComplete: function(result) {
            if (result.naturalWidth === 0) {
                setImgSrc(fallbackSrc || _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
            }
        },
        onError: function() {
            setImgSrc(fallbackSrc || _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
        },
        onClick: onClick
    }));
};


/***/ }),

/***/ 59129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71232);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1985);






var CSelector = function(param) {
    var data = param.data, initialState = param.initialState, fieldLabel = param.fieldLabel, placeholder = param.placeholder, description = param.description, clearable = param.clearable, icon = param.icon, onChange = param.onChange;
    var SelectItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
        var label = _param.label, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
            "label"
        ]);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Group */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            noWrap: true,
            ref: ref
        }, others), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                size: "sm",
                children: label
            })
        }));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Select */ .Ph, {
        // mt="sm"
        radius: "xs",
        label: fieldLabel,
        placeholder: placeholder,
        description: description,
        onChange: function(val) {
            if (onChange) onChange(val);
        },
        itemComponent: SelectItem,
        allowDeselect: false,
        clearable: clearable,
        nothingFound: "No options",
        maxDropdownHeight: 400,
        transition: "pop-top-left",
        transitionDuration: 80,
        transitionTimingFunction: "ease",
        data: data,
        value: initialState,
        // data={[{ value: '1', label: '1' }]}
        // value="1"
        icon: icon
    });
};


/***/ }),

/***/ 33451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64761);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36972);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34065);


function useDxbTheme() {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_0__/* .useMantineTheme */ .rZ)();
    var colorScheme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .useMantineColorScheme */ .X)().colorScheme;
    var isDark = colorScheme === "dark";
    var isLight = colorScheme === "light";
    var isSmallScreen = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .a)("(min-width: 500px)");
    return {
        isDark: isDark,
        isLight: isLight,
        colorScheme: colorScheme,
        theme: theme,
        isSmallScreen: isSmallScreen
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useDxbTheme);


/***/ }),

/***/ 10773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useIsMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsMounted(true);
    }, []);
    return isMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsMounted);


/***/ }),

/***/ 51888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DXBImageView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_network_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41448);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82623);
/* harmony import */ var _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52009);









var DXBImageView = function(props) {
    // const { classes } = useStyles();
    var _src = props.src, fallbackSrc = props.fallbackSrc, alt = props.alt, onClick = props.onClick, className = props.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, [
        "src",
        "fallbackSrc",
        "alt",
        "onClick",
        "className"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_src), imgSrc = ref[0], setImgSrc = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setImgSrc(_src);
    }, []);
    var url = _src === undefined || _src === null ? _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : imgSrc;
    // const [isLoading, setIsLoading] = useState(true);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Paper */ .X, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
            className: className,
            placeholder: "blur",
            blurDataURL: _utils_network_utils__WEBPACK_IMPORTED_MODULE_3__/* .BLUR_DATA */ .Vc,
            src: url,
            alt: alt,
            onLoadingComplete: function(result) {
                // setIsLoading(false);
                if (result.naturalWidth === 0) {
                    setImgSrc(fallbackSrc || _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
                }
            },
            onError: function() {
                setImgSrc(fallbackSrc || _public_images_placeholder_600x300_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
            },
            onClick: onClick,
            layout: "responsive",
            objectFit: "cover"
        }))
    });
};


/***/ }),

/***/ 23377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ClientOnly; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var ClientOnly = function(_param) {
    var children = _param.children, delegated = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasMounted = ref[0], setHasMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, delegated), {
        children: children
    }));
};


/***/ }),

/***/ 63298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(26509);
// EXTERNAL MODULE: ./src/core/hooks/use-is-mounted.ts
var use_is_mounted = __webpack_require__(10773);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./src/lib/ClientOnly.tsx
var ClientOnly = __webpack_require__(23377);
// EXTERNAL MODULE: ./src/core/utils/dxb-utils.ts
var dxb_utils = __webpack_require__(10646);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(97564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
;// CONCATENATED MODULE: ./src/core/components/common/CSection.tsx




var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        h1: (0,_define_property/* default */.Z)({
            fontSize: 28,
            letterSpacing: 0.6,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.dark[4]
        }, theme.fn.smallerThan("sm"), {
            fontSize: 20
        })
    };
});
/**
 *
 * Use only when you have to render into a page section
 * with headings
 *
 * */ var CSection = function(param) {
    var heading = param.heading, content = param.content, className = param.className;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        mt: 30,
        mb: 30,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                mb: 30,
                className: classes.h1,
                order: 1,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: content
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/core/hooks/use-app-data.ts
var use_app_data = __webpack_require__(81819);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(20966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/querystring-es3/index.js
var querystring_es3 = __webpack_require__(97334);
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);
// EXTERNAL MODULE: ./src/features/common/hooks/use-user-data.ts
var use_user_data = __webpack_require__(85992);
// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
// EXTERNAL MODULE: ./src/core/components/common/CSelector.tsx
var CSelector = __webpack_require__(59129);
// EXTERNAL MODULE: ./src/core/providers/BookingStateProvider.tsx + 1 modules
var BookingStateProvider = __webpack_require__(97771);
;// CONCATENATED MODULE: ./src/features/booking/components/GuestsCount/GuestCountSelector.tsx






var GuestCountSelector = function() {
    var ref;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref1 = (0,BookingStateProvider/* useBookingState */.hg)(), setGuestsCount = ref1.setGuestsCount, getGuestLimit = ref1.getGuestLimit;
    var ref2 = (0,react.useState)(getGuestLimit().length.toString()), initialCount = ref2[0], setInitialCount = ref2[1];
    var getDefaultRows = (ref = getGuestLimit()) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
        var row = (item === null || item === void 0 ? void 0 : item.count) === 1 ? "".concat(item === null || item === void 0 ? void 0 : item.count, " guest") : "".concat(item === null || item === void 0 ? void 0 : item.count, " guests");
        return {
            label: row,
            value: item === null || item === void 0 ? void 0 : item.count.toString()
        };
    });
    (0,react.useEffect)(function() {
        setGuestsCount(parseInt(initialCount, 10));
    }, []);
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSelector/* CSelector */.n, {
        data: getDefaultRows,
        initialState: initialCount,
        clearable: true,
        placeholder: "Select guests",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconHotelService */.dO, {
            size: 24,
            stroke: 0.6
        }),
        onChange: function(value) {
            setGuestsCount(parseInt(value, 10));
            setInitialCount(value);
        }
    });
};

;// CONCATENATED MODULE: ./src/features/booking/components/Summary/DxbPriceSummary.tsx





var DxbPriceSummary = function() {
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var dxbPricesCalculatedByRules = (0,BookingStateProvider/* useBookingState */.hg)().dxbPricesCalculatedByRules;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        m: 0,
        p: 0,
        children: dxbPricesCalculatedByRules === null || dxbPricesCalculatedByRules === void 0 ? void 0 : dxbPricesCalculatedByRules.map(function(priceItem, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    mb: 10,
                    grow: true,
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            align: "left",
                            children: [
                                priceItem.typeName,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    align: "left",
                                    size: 10,
                                    children: priceItem.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            align: "right",
                            children: [
                                "AED ",
                                priceItem.amount
                            ]
                        })
                    ]
                })
            }, idx);
        })
    });
};

;// CONCATENATED MODULE: ./src/features/booking/components/Summary/PriceSummary.tsx






var PriceSummary = function() {
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var priceCalculations = (0,BookingStateProvider/* useBookingState */.hg)().priceCalculations;
    var nightsText = "AED ".concat(priceCalculations.pricePerNight, " x ").concat(priceCalculations.totalNights, " Nights");
    var totalPriceText = "AED ".concat(priceCalculations.totalPrice);
    var dxbPriceText = "AED ".concat(priceCalculations.dxbTotalPrice);
    var grandTotalText = "AED ".concat(priceCalculations.grandTotalPrice);
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                align: "center",
                size: "sm",
                mb: 30,
                children: "You won't be charged yet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                grow: true,
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        align: "left",
                        children: [
                            "Booking Price",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                align: "left",
                                size: 10,
                                children: nightsText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        align: "right",
                        children: totalPriceText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DxbPriceSummary, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                ml: -20,
                mr: -20,
                mt: 20,
                mb: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                grow: true,
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        align: "left",
                        children: "Grand TOTAL"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        align: "right",
                        children: grandTotalText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                grow: false,
                spacing: 0,
                mt: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: "xs",
                        children: "** Tourism fees only applies to the first 30 nights of your stay."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: "xs",
                        children: "** Security deposits are refundable."
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/booking/components/PricePerNight.tsx





var PricePerNight_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        priceGroup: {
        },
        priceCurrency: {
            marginBottom: 0,
            position: "relative",
            bottom: 13,
            fontSize: 16,
            fontWeight: 400,
            marginRight: 4
        },
        priceAmount: {
            marginBottom: 0,
            marginTop: 0,
            fontSize: 36,
            textAlign: "center",
            fontWeight: 400
        },
        priceDuration: {
            marginTop: 0,
            position: "relative",
            top: 4,
            fontSize: 20,
            fontWeight: 400
        }
    };
});
var PricePerNight = function() {
    var classes = PricePerNight_useStyles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var priceCalculations = (0,BookingStateProvider/* useBookingState */.hg)().priceCalculations;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        className: classes.priceGroup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
            style: {
                flex: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classes.priceCurrency,
                    children: "AED"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classes.priceAmount,
                    children: priceCalculations.pricePerNight
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: classes.priceDuration,
                    children: "/ night"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
// EXTERNAL MODULE: ./node_modules/@mantine/dates/esm/components/RangeCalendar/RangeCalendar.js + 32 modules
var RangeCalendar = __webpack_require__(28807);
// EXTERNAL MODULE: ./src/core/utils/date-utils.ts
var date_utils = __webpack_require__(54938);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(10753);
// EXTERNAL MODULE: ./src/core/components/common/CIconButton.tsx
var CIconButton = __webpack_require__(49847);
// EXTERNAL MODULE: ./src/core/providers/PropertyStateProvider.tsx
var PropertyStateProvider = __webpack_require__(86727);
// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
;// CONCATENATED MODULE: ./src/features/booking/components/RangeSelector/BookingRangeSelector.styles.ts


/* harmony default export */ var BookingRangeSelector_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1, _obj2, _obj3;
    return {
        calStack: {
            alignItems: "center",
            width: "100%"
        },
        calendarBase: (_obj1 = {
            maxWidth: "100%",
            width: "100%",
            alignItems: "center",
            marginTop: 20,
            marginBottom: 20,
            padding: 20,
            paddingBottom: 30,
            border: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            borderRadius: theme.radius.xs,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            flexDirection: "column"
        }, (0,_define_property/* default */.Z)(_obj1, theme.fn.smallerThan("sm"), {
            width: "auto",
            padding: 10,
            paddingBottom: 30,
            paddingTop: 30
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-calendarHeader", {
            height: 55,
            borderBottom: 1,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            borderColor: theme.colors.orange[5],
            borderStyle: "dashed",
            paddingTop: 5,
            paddingBottom: 5,
            color: theme.colors.dark[3]
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-calendarHeaderLevel", {
            color: theme.colors.dark[2],
            borderRadius: theme.radius.md,
            // position: 'absolute',
            fontSize: 16,
            fontWeight: 400,
            letterSpacing: 1
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-calendarHeaderControl", {
            borderRadius: theme.radius.md,
            // position: 'absolute',
            // marginRight: 40,
            // right: 0,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
            "&:hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.gray[7] : theme.colors.gray[4]
            }
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-month", {
            width: "100%"
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-weekday", (0,_define_property/* default */.Z)({
            borderBottom: 1,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            borderColor: theme.colors.orange[5],
            borderStyle: "dashed",
            paddingBottom: 10,
            fontSize: 14,
            letterSpacing: 1,
            textTransform: "uppercase"
        }, theme.fn.smallerThan("sm"), {
            fontSize: 12
        })), /*'.mantine-RangeCalendar-weekdayCell': {
            paddingBottom: 10,
        },*/ (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-cell", {
            textAlign: "center"
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-day", (_obj = {
            margin: 4,
            borderRadius: theme.radius.md,
            // width: '100%',
            fontSize: 14
        }, // width: 34,
        // height: 34,
        (0,_define_property/* default */.Z)(_obj, theme.fn.smallerThan("sm"), {
            fontSize: 12
        }), (0,_define_property/* default */.Z)(_obj, "&[data-selected]", {
            backgroundColor: theme.colors.orange[4],
            borderRadius: theme.radius.md,
            position: "relative"
        }), (0,_define_property/* default */.Z)(_obj, "&[data-in-range]", {
            backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.orange[7], 0.2) : theme.colors.orange[0],
            borderRadius: theme.radius.md
        }), (0,_define_property/* default */.Z)(_obj, "&[data-first-in-range]", {
            backgroundColor: theme.colors.orange[4],
            borderRadius: theme.radius.md,
            position: "relative",
            "&::after": {
                content: '""',
                backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.orange[7], 0.2) : theme.colors.orange[0],
                position: "absolute",
                right: 0,
                left: 20,
                top: 0,
                bottom: 0,
                zIndex: -1
            }
        }), (0,_define_property/* default */.Z)(_obj, "&[data-last-in-range]", {
            backgroundColor: theme.colors.orange[4],
            borderRadius: theme.radius.md,
            "&::after": {
                content: '""',
                backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.orange[7], 0.2) : theme.colors.orange[0],
                position: "absolute",
                left: 0,
                right: 20,
                top: 0,
                bottom: 0,
                zIndex: -1
            }
        }), (0,_define_property/* default */.Z)(_obj, "&[data-weekend]", {
            color: theme.colors.orange[5]
        }), (0,_define_property/* default */.Z)(_obj, "&[disabled]", {
            color: theme.colors.gray[5],
            textDecoration: "line-through",
            textDecorationColor: theme.colors.orange[5]
        }), _obj)), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-monthPickerControl", {
            margin: 2,
            flex: "0 0 20%"
        }), (0,_define_property/* default */.Z)(_obj1, ".mantine-RangeCalendar-monthPickerControlActive", {
            backgroundColor: theme.colors.orange[3],
            "&:hover": {
                backgroundColor: theme.colors.orange[5]
            }
        }), _obj1),
        checkWrapper: {
            marginTop: 2,
            gap: 0
        },
        checkInMain: (_obj2 = {
            position: "relative",
            height: "auto",
            width: "50%",
            paddingRight: theme.spacing.sm,
            borderRadius: theme.radius.xs
        }, (0,_define_property/* default */.Z)(_obj2, theme.fn.largerThan("sm"), {
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            borderRight: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }), (0,_define_property/* default */.Z)(_obj2, theme.fn.smallerThan("sm"), {
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            borderBottom: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            width: "100%"
        }), _obj2),
        checkOutMain: (_obj3 = {
            position: "relative",
            height: "auto",
            width: "50%",
            paddingRight: theme.spacing.sm,
            borderRadius: theme.radius.xs
        }, (0,_define_property/* default */.Z)(_obj3, theme.fn.largerThan("sm"), {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }), (0,_define_property/* default */.Z)(_obj3, theme.fn.smallerThan("sm"), {
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            width: "100%"
        }), _obj3),
        checkLabel: {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 10,
            fontWeight: 500,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            zIndex: 1
        },
        checkDescription: {
            position: "absolute",
            pointerEvents: "none",
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            lineHeight: 1.2,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
            zIndex: 1
        },
        checkInput: {
            height: "auto",
            minWidth: 150,
            lineHeight: "34px",
            paddingLeft: theme.spacing.sm,
            paddingRight: theme.spacing.sm,
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
        },
        checkClearIcon: {
            width: "100%"
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/booking/components/RangeSelector/BookingRangeSelector.tsx














var BookingRangeSelector = function() {
    var cleanup = // RESET LOCAL STATE ONLY
    function cleanup() {
        setSelectedBookingRange([
            null,
            null
        ]);
        setSelectedDates([
            null,
            null
        ]);
        resetPrices();
    };
    var classes = BookingRangeSelector_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref = (0,BookingStateProvider/* useBookingState */.hg)(), propertyCalendarPrices = ref.propertyCalendarPrices, setSelectedBookingRange = ref.setSelectedBookingRange, bookingInfo = ref.bookingInfo, selectedDates = ref.selectedDates, setSelectedDates = ref.setSelectedDates, calculatePricesAndStore = ref.calculatePricesAndStore, resetPrices = ref.resetPrices;
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    var ref1 = (0,react.useState)(false), isClearVisible = ref1[0], setIsClearVisible = ref1[1];
    var ref2 = (0,react.useState)(false), isRangeVisible = ref2[0], setIsRangeVisible = ref2[1];
    // GOOD BOY
    var ref3 = (0,use_click_outside/* useClickOutside */.O)(function() {
        setIsRangeVisible(false);
    });
    (0,react.useEffect)(function() {
        if (bookingInfo) {
            setSelectedDates(selectedDates);
            if (bookingInfo.start_date !== "") {
                setIsClearVisible(true);
            }
        }
    }, [
        bookingInfo
    ]);
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        className: classes.checkWrapper,
        children: [
            selectedDates !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                className: classes.checkInMain,
                onClick: function() {
                    setIsRangeVisible(true);
                    // RESETTING WHEN SELECTING RANGE
                    setIsClearVisible(false);
                    cleanup();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.checkLabel,
                            children: "Check in"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.checkDescription,
                            children: "When will your arrive?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.checkInput,
                            children: (0,date_utils/* formatBookingCardRangeDate */.M4)(selectedDates[0], "Add date")
                        })
                    ]
                })
            }),
            selectedDates !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                className: classes.checkOutMain,
                onClick: function() {
                    setIsRangeVisible(true);
                    // RESETTING WHEN SELECTING RANGE
                    setIsClearVisible(false);
                    cleanup();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.checkLabel,
                            children: "Check out"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.checkDescription,
                            children: "When do you plan to leave?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.checkInput,
                            children: (0,date_utils/* formatBookingCardRangeDate */.M4)(selectedDates[1], "Add date")
                        })
                    ]
                })
            }),
            isClearVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(CIconButton/* CIconButton */.E, {
                className: classes.checkClearIcon,
                label: "Clear calendar dates",
                onClick: function() {
                    setIsClearVisible(false);
                    cleanup();
                },
                light: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconX */.kLi, {
                    color: "orange",
                    size: 24
                }),
                dark: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconX */.kLi, {
                    color: "orange",
                    size: 24
                }),
                props: {
                    variant: "light",
                    p: 20,
                    mt: 20
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                className: classes.calStack,
                children: isRangeVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeCalendar/* RangeCalendar */.V, {
                    className: classes.calendarBase,
                    ref: ref3,
                    value: selectedDates,
                    onChange: function(range) {
                        // FOR BOOKING INFO
                        setSelectedBookingRange(range);
                        // DON'T ALLOW SAME RANGE AGAIN -
                        // CURRENTLY NOT NECESSARY BUT STILL FOR THE EDGE CASES
                        // WE WILL MATCH THE DATES.
                        if (!(0,date_utils/* matchDates */.po)(range, selectedDates)) {
                            // LOCAL STATE
                            setSelectedDates((0,_to_consumable_array/* default */.Z)(range));
                            // LOCAL STATE
                            calculatePricesAndStore(range);
                            if (range[1] !== null) {
                                setIsRangeVisible(false);
                                setIsClearVisible(true);
                            //onRangeSelection(range);
                            }
                        }
                    },
                    excludeDate: function(date) {
                        var ref;
                        if (((ref = propertyDetailsData.settings) === null || ref === void 0 ? void 0 : ref.calendarState) === graphql/* RecordStatus.Disabled */.rf.Disabled) {
                            return true;
                        } else {
                            return (0,date_utils/* disablePastAndControlledDates */.Ud)(date, (0,date_utils/* getBlockedDatesFromCalendar */.sx)(propertyCalendarPrices.smoobu));
                        }
                    },
                    sx: classes,
                    firstDayOfWeek: "monday",
                    weekendDays: [
                        0
                    ],
                    allowLevelChange: false,
                    disableOutsideEvents: false,
                    amountOfMonths: 1
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/next/esm/NextLink.js
var NextLink = __webpack_require__(8798);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 8 modules
var Modal = __webpack_require__(6591);
// EXTERNAL MODULE: ./src/core/router/AppRoutes.ts
var AppRoutes = __webpack_require__(84396);
// EXTERNAL MODULE: ./src/core/hooks/use-dxb-theme.ts
var use_dxb_theme = __webpack_require__(33451);
;// CONCATENATED MODULE: ./src/features/booking/components/AuthModal/AuthModal.styles.ts

/* harmony default export */ var AuthModal_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        modalWrapper: {
            ".mantine-Modal-header": {
                marginRight: 0
            },
            ".mantine-Modal-title": {
                marginRight: 0,
                width: "100%",
                textAlign: "center"
            }
        },
        modalButtons: {
            fontWeight: 400
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/booking/components/AuthModal/AuthModal.tsx










var AuthModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var classes = AuthModal_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref = (0,use_dxb_theme/* default */.Z)(), isDark = ref.isDark, theme = ref.theme;
    var router = (0,next_router.useRouter)();
    var slug = router.query.slug;
    var setLastPage = (0,use_app_data/* default */.Z)().setLastPage;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
            className: classes.modalWrapper,
            overlayColor: isDark ? theme.colors.dark[9] : theme.colors.gray[2],
            overlayOpacity: 0.55,
            overlayBlur: 3,
            centered: true,
            withCloseButton: true,
            title: "Would you like to make a booking?",
            onClose: function() {
                return onClose();
            },
            opened: open,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    align: "center",
                    size: "sm",
                    color: "orange",
                    children: "Please log in or sign up to make bookings."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: classes.modalButtons,
                    component: NextLink/* NextLink */.p,
                    title: "Log in to your account",
                    variant: "filled",
                    radius: "xs",
                    mt: "xl",
                    fullWidth: true,
                    href: AppRoutes/* AppRoutes.LOGIN */.$w.LOGIN,
                    onClick: function() {
                        //setLastRoute(getPageRoute(AppRoutes.PROPERTIES, slug.toString()));
                        setLastPage((0,AppRoutes/* getPageRoute */.ul)(AppRoutes/* AppRoutes.PROPERTIES */.$w.PROPERTIES, slug.toString())); // TODO: FLOW TEST
                    },
                    children: "Log in to your account"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: classes.modalButtons,
                    component: NextLink/* NextLink */.p,
                    title: "Sign up for an account",
                    variant: "filled",
                    radius: "xs",
                    mt: "xl",
                    fullWidth: true,
                    href: AppRoutes/* AppRoutes.REGISTER */.$w.REGISTER,
                    onClick: function() {
                        //setLastRoute(getPageRoute(AppRoutes.PROPERTIES, slug.toString()));
                        setLastPage((0,AppRoutes/* getPageRoute */.ul)(AppRoutes/* AppRoutes.PROPERTIES */.$w.PROPERTIES, slug.toString())); // TODO: FLOW TEST
                    },
                    children: "Create an account..."
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/booking/components/BookingSuccessModal/BookingSuccessModal.styles.ts

/* harmony default export */ var BookingSuccessModal_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        modalWrapper: {
            ".mantine-Modal-header": {
                marginRight: 0
            },
            ".mantine-Modal-title": {
                marginRight: 0,
                width: "100%",
                textAlign: "center"
            },
            ".mantine-Modal-close:focus": {
                outline: 0
            }
        },
        modalButtons: {
            fontWeight: 400
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/booking/components/BookingSuccessModal/BookingSuccessModal.tsx








var BookingSuccessModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var classes = BookingSuccessModal_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref = (0,use_dxb_theme/* default */.Z)(), isDark = ref.isDark, theme = ref.theme;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            className: classes.modalWrapper,
            overlayColor: isDark ? theme.colors.dark[9] : theme.colors.gray[2],
            overlayOpacity: 0.55,
            overlayBlur: 3,
            centered: true,
            withCloseButton: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
            title: "Your booking was successful!",
            onClose: function() {
                onClose();
            },
            opened: open,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: classes.modalButtons,
                component: NextLink/* NextLink */.p,
                title: "Booking Details",
                href: AppRoutes/* AppRoutes.BOOKINGS */.$w.BOOKINGS,
                variant: "filled",
                radius: "xs",
                mt: "xl",
                fullWidth: true,
                onClick: function() {
                    return onClose();
                },
                children: "Booking details"
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/booking/components/BookingCard.styles.ts

/* harmony default export */ var BookingCard_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        paper: {
            // margin: '0 auto',
            textAlign: "justify",
            fontSize: 13,
            maxWidth: "100%",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
            boxShadow: theme.shadows.sm,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        },
        progress: {
            textAlign: "center"
        },
        bookNowButton: {
            background: theme.fn.linearGradient(30, theme.colors.orange[5], theme.colors.yellow[5]),
            textTransform: "uppercase",
            fontWeight: 500,
            letterSpacing: 1,
            "&[data-disabled]": {
                background: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3]
            }
        },
        readyToBookText: {
            flex: 2,
            textAlign: "center",
            textTransform: "uppercase",
            paddingTop: 10,
            paddingBottom: 10,
            borderColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[4],
            fontSize: 13,
            maxWidth: "100%",
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: theme.radius.xs
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/booking/components/MinimumNights/MinimumNightsBadge.styles.ts

/* harmony default export */ var MinimumNightsBadge_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        nightBadgeBooking: {
            position: "absolute",
            right: 0,
            top: 0
        },
        minBadgeTitle: {
            textTransform: "uppercase",
            textAlign: "center",
            fontSize: 10,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 8,
            paddingRight: 8,
            background: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
            color: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[6],
            borderBottomLeftRadius: theme.radius.xs,
            borderTopRightRadius: theme.radius.xs,
            letterSpacing: 1,
            lineHeight: 1.2
        },
        minBadgeText: {
            display: "inline-flex",
            textTransform: "uppercase",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            fontSize: 24,
            fontWeight: 200,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
        },
        icon: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5],
            marginLeft: 6,
            fontSize: 24
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/booking/components/MinimumNights/MinimumNightsBadge.tsx







var MinimumNightsBadge = function() {
    var ref;
    var classes = MinimumNightsBadge_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        className: classes.nightBadgeBooking,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    className: classes.minBadgeTitle,
                    order: 1,
                    children: "Min Booking"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: classes.minBadgeText,
                    children: [
                        propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref = propertyDetailsData.settings) === null || ref === void 0 ? void 0 : ref.minimumNights,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMoonStars */.zG9, {
                            className: classes.icon,
                            stroke: 1
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/booking/components/BookingCard.tsx


















var BookingCard = function() {
    var mountLock = (0,react.useRef)(true);
    var classes = BookingCard_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref = (0,react.useState)(false), isAuthModalVisible = ref[0], setIsAuthModalVisible = ref[1];
    var ref1 = (0,react.useState)(false), isBookingSuccessModalVisible = ref1[0], setIsBookingSuccessModalVisible = ref1[1];
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    var ref2 = (0,BookingStateProvider/* useBookingState */.hg)(), setPropertyCalendarPrices = ref2.setPropertyCalendarPrices, createBookingPaymentSession = ref2.createBookingPaymentSession, isReadyToBook = ref2.isReadyToBook;
    var isUser = (0,use_user_data/* default */.Z)().isUser;
    // CALLS
    var ref3 = (0,graphql/* useGetPricesQuery */.Bz)({
        variables: {
            smoobuId: propertyDetailsData.smoobu_id,
            propertyId: propertyDetailsData.id
        },
        onCompleted: function(query) {
            var ref, ref1;
            setPropertyCalendarPrices({
                dxbstay: (ref = query.getPrices) === null || ref === void 0 ? void 0 : ref.dxbstay,
                smoobu: (ref1 = query.getPrices) === null || ref1 === void 0 ? void 0 : ref1.smoobu
            });
        //setSmoobuPropId(propertyDetailsData.smoobu_id);
        //setDXBPropId(propertyDetailsData.id);
        }
    }), data = ref3.data, loading = ref3.loading;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(false), bookingLoading = ref4[0], setBookingLoading = ref4[1];
    var submitBooking = function() {
        // MAKE SURE USER IS LOGGED IN
        // IF NOT SHOW HIM/HER THE AUTH MODEL
        if (!isUser()) {
            setIsAuthModalVisible(true);
        } else {
            // AND HIS PASSPORT COPY IS WITH US BEFORE BOOKING
            /*isPassportApproved()
                .then((status) => {
                    if (status) {
                        setBookingLoading(true);

                        createBookingPaymentSession()
                            .then((res) => {

                                // console.log(res, 'BookingPaymentSession :: DONE')

                                setBookingLoading(false);

                                if (res.status) {
                                    router.push(res.url).catch(console.error)
                                }

                            })
                            .catch(() => {
                                setBookingLoading(false);
                            });
                    }
                }).catch(() => console.error('User profile is not complete'))*/ // NOT CHECKING FOR PASSPORT
            setBookingLoading(true);
            createBookingPaymentSession().then(function(res) {
                // console.log(res, 'BookingPaymentSession :: DONE')
                setBookingLoading(false);
                if (res.status) {
                    router.push(res.url).catch(console.error);
                }
            }).catch(function() {
                setBookingLoading(false);
            });
        }
    };
    (0,react.useEffect)(function() {
        if (mountLock.current) {
            mountLock.current = false;
            // DO NOT CHANGE ROUTER RELATED STUFF - CAUSING UN KNOWN BEHAVIOUR
            var path = router.asPath.split("?");
            if (path.length) {
                // const slug = path[0];
                var query = path[1]; //booking=true booking=false
                var queryStr = querystring_es3_default().parse(query);
                if (queryStr.booking === "true") {
                    setIsBookingSuccessModalVisible(true);
                }
                // IF USER PRESSES BACK BUTTON TO COME BACK TO THIS PAGE
                if (queryStr.booking === "false") {
                // USER CAME BACK BY PAYMENT PAGE
                }
            }
        // console.log('BOOKING CARD PATH', "-")
        }
    }, []);
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        p: 0,
        children: [
            isAuthModalVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {
                open: isAuthModalVisible,
                onClose: function() {
                    setIsAuthModalVisible(false);
                }
            }),
            isBookingSuccessModalVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSuccessModal, {
                open: isBookingSuccessModalVisible,
                onClose: function() {
                    setIsBookingSuccessModalVisible(false);
                }
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                mt: 30,
                className: classes.progress,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: "#f39c12",
                    variant: "dots",
                    size: "sm"
                })
            }),
            (data === null || data === void 0 ? void 0 : data.getPrices) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                className: classes.paper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card.Section */.Z.Section, {
                            p: 20,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PricePerNight, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MinimumNightsBadge, {})
                                    ]
                                }),
                                !isReadyToBook() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    className: classes.readyToBookText,
                                    color: "orange",
                                    mt: 10,
                                    mb: -8,
                                    children: "Select dates to show price"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            pt: 0,
                            pb: 0,
                            p: 20,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingRangeSelector, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestCountSelector, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            pt: 0,
                            p: 20,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: classes.bookNowButton,
                                disabled: !isReadyToBook(),
                                loading: bookingLoading,
                                // variant="gradient"
                                style: {
                                    fontWeight: 400
                                },
                                radius: "xs",
                                mt: "xl",
                                fullWidth: true,
                                onClick: function() {
                                    return submitBooking();
                                },
                                children: "Book Now"
                            })
                        }),
                        isReadyToBook() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            pt: 0,
                            p: 20,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSummary, {})
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/property-details/components/Title/DetailsTitle.styles.ts


/* harmony default export */ var DetailsTitle_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        h1: (0,_define_property/* default */.Z)({
            fontSize: 28,
            letterSpacing: 0.6,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.dark[4]
        }, theme.fn.smallerThan("sm"), {
            fontSize: 18
        }),
        h2: (0,_define_property/* default */.Z)({
            letterSpacing: 0.6,
            color: theme.colorScheme === "dark" ? theme.colors.gray[5] : theme.colors.dark[4]
        }, theme.fn.smallerThan("sm"), {
            fontSize: 14
        }),
        titleLocation: (0,_define_property/* default */.Z)({
            display: "inline-flex",
            gap: theme.spacing.xs,
            flexWrap: "nowrap"
        }, theme.fn.smallerThan("sm"), {
            // fontSize: 18,
            // height: 23,
            // alignItems: 'flex-start',
            // overflow: 'hidden',
            flexWrap: "nowrap"
        }),
        locationIcon: {
            height: 24,
            minWidth: 24
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/components/Title/DetailsTitle.tsx





var DetailsTitle = function(param) {
    var name = param.name, address = param.address;
    var classes = DetailsTitle_styles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                lineClamp: 1,
                className: classes.h1,
                order: 1,
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                className: classes.titleLocation,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMap2 */.DZw, {
                        className: classes.locationIcon,
                        stroke: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        lineClamp: 1,
                        className: classes.h2,
                        order: 2,
                        children: address
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(20050);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 1 modules
var SimpleGrid = __webpack_require__(69469);
// EXTERNAL MODULE: ./src/features/common/DXBImageView.tsx
var DXBImageView = __webpack_require__(51888);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/Lightbox.js + 8 modules
var Lightbox = __webpack_require__(25559);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/captions/index.js + 5 modules
var captions = __webpack_require__(44548);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/index.js + 5 modules
var thumbnails = __webpack_require__(52806);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/zoom/index.js + 6 modules
var zoom = __webpack_require__(94500);
// EXTERNAL MODULE: ./src/core/utils/network-utils.ts
var network_utils = __webpack_require__(41448);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/styles.css
var styles = __webpack_require__(50781);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/captions/captions.css
var captions_captions = __webpack_require__(41879);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css
var thumbnails_thumbnails = __webpack_require__(53402);
;// CONCATENATED MODULE: ./src/features/property-details/components/Gallery/ImageGalleryModal.tsx














var ImageGalleryModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var ref = (0,PropertyStateProvider/* usePropertyState */.Vk)(), getAllGalleryImages = ref.getAllGalleryImages, selectedImageIndex = ref.selectedImageIndex;
    var mountLock = (0,react.useRef)(true);
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var ref1 = (0,react.useState)([]), data = ref1[0], setData = ref1[1];
    // THUMBNAIL CAROUSAL
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(120), 2), width = ref2[0], setWidth = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(80), 2), height = ref3[0], setHeight = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), border = ref4[0], setBorder = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(4), 2), borderRadius = ref5[0], setBorderRadius = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(4), 2), padding = ref6[0], setPadding = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(16), 2), gap = ref7[0], setGap = ref7[1];
    //CAROUSEL
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(2), 2), preload = ref8[0], setPreload = ref8[1];
    // ZOOM
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(500), 2), animationDuration = ref9[0], setAnimationDuration = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), maxZoomPixelRatio = ref10[0], setMaxZoomPixelRatio = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(2), 2), zoomInMultiplier = ref11[0], setZoomInMultiplier = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(300), 2), doubleTapDelay = ref12[0], setDoubleTapDelay = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)(react.useState(300), 2), doubleClickDelay = ref13[0], setDoubleClickDelay = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)(react.useState(2), 2), doubleClickMaxStops = ref14[0], setDoubleClickMaxStops = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)(react.useState(50), 2), keyboardMoveDistance = ref15[0], setKeyboardMoveDistance = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)(react.useState(100), 2), wheelZoomDistanceFactor = ref16[0], setWheelZoomDistanceFactor = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)(react.useState(100), 2), pinchZoomDistanceFactor = ref17[0], setPinchZoomDistanceFactor = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), scrollToZoom = ref18[0], setScrollToZoom = ref18[1];
    (0,react.useEffect)(function() {
        if (mountLock.current) {
            var ref;
            mountLock.current = false;
            // console.log(files, 'gallery-files')
            // console.log(initialIndex, 'initialIndex')
            var arrayImage = (ref = getAllGalleryImages()) === null || ref === void 0 ? void 0 : ref.map(function(file, idx) {
                var imageSrc = "".concat(network_utils/* S3_PROPERTY_BUCKET_URL */.oe, "/").concat(file.src);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, file), {
                    src: imageSrc,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        weight: 400,
                        children: file.title
                    }),
                    key: idx
                });
            });
            setData(arrayImage);
        }
    }, []);
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbox/* Lightbox */.e, {
        open: open,
        index: selectedImageIndex,
        close: function() {
            return onClose();
        },
        slides: data,
        carousel: {
            preload: preload
        },
        plugins: [
            captions/* default */.Z,
            thumbnails/* default */.Z,
            zoom/* default */.ZP
        ],
        thumbnails: {
            position: "bottom",
            width: width,
            height: height,
            border: border,
            borderRadius: borderRadius,
            padding: padding,
            gap: gap
        },
        animation: {
            swipe: 300,
            zoom: animationDuration
        },
        zoom: {
            maxZoomPixelRatio: maxZoomPixelRatio,
            zoomInMultiplier: zoomInMultiplier,
            doubleTapDelay: doubleTapDelay,
            doubleClickDelay: doubleClickDelay,
            doubleClickMaxStops: doubleClickMaxStops,
            keyboardMoveDistance: keyboardMoveDistance,
            wheelZoomDistanceFactor: wheelZoomDistanceFactor,
            pinchZoomDistanceFactor: pinchZoomDistanceFactor,
            scrollToZoom: scrollToZoom
        }
    });
};

;// CONCATENATED MODULE: ./src/features/property-details/components/Gallery/DetailsGallery.styles.ts

/* harmony default export */ var DetailsGallery_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        galleryContainer: {
            maxWidth: theme.other.maxWidth,
            "span": {
                height: "100% !important",
                width: "100% !important"
            }
        },
        imageStyles: {
            borderRadius: theme.radius.xs,
            cursor: "pointer"
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/components/Gallery/DetailsGallery.tsx








var DetailsGallery = function() {
    var ref, ref1, ref2;
    // const mountLock = useRef(true)
    var classes = DetailsGallery_styles().classes;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var ref3 = (0,PropertyStateProvider/* usePropertyState */.Vk)(), getGalleryFrontImages = ref3.getGalleryFrontImages, findImageIndex = ref3.findImageIndex;
    // CALCULATIONS
    var PRIMARY_COL_WIDTH = 576;
    var PRIMARY_COL_HEIGHT = PRIMARY_COL_WIDTH / 1.5;
    var SECONDARY_COL_HEIGHT = PRIMARY_COL_WIDTH / 1.5 - theme.spacing.md / 2;
    // GALLERY
    var ref4 = (0,react.useState)(false), showImageGalleryModal = ref4[0], setShowImageGalleryModal = ref4[1];
    var PreviewImage = function(param) {
        var src = param.src, alt = param.alt, width = param.width, height = param.height;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DXBImageView/* DXBImageView */.H, {
            onClick: function() {
                findImageIndex(alt);
                setShowImageGalleryModal(true);
            // console.log(image, 'ASIM')
            },
            width: width,
            height: height,
            src: "".concat(network_utils/* S3_PROPERTY_BUCKET_URL */.oe, "/").concat(src),
            alt: alt,
            priority: true,
            className: classes.imageStyles
        });
    };
    var frontSecondaryImages = getGalleryFrontImages().slice(1, getGalleryFrontImages().length).map(function(image, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
            span: 6,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewImage, {
                src: image.src,
                alt: image.alt,
                width: PRIMARY_COL_WIDTH,
                height: SECONDARY_COL_HEIGHT
            })
        }, idx);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        my: "md",
        className: classes.galleryContainer,
        mt: 20,
        mb: 20,
        m: 0,
        p: 0,
        children: [
            showImageGalleryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGalleryModal, {
                open: showImageGalleryModal,
                onClose: function() {
                    setShowImageGalleryModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleGrid/* SimpleGrid */.M, {
                cols: 2,
                breakpoints: [
                    {
                        maxWidth: "sm",
                        cols: 1
                    }
                ],
                children: [
                    ((ref = getGalleryFrontImages()) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewImage, {
                        src: (ref2 = getGalleryFrontImages()[0]) === null || ref2 === void 0 ? void 0 : ref2.src,
                        alt: getGalleryFrontImages()[0].alt,
                        width: PRIMARY_COL_WIDTH,
                        height: PRIMARY_COL_HEIGHT
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                        gutter: "md",
                        children: frontSecondaryImages
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/property-details/components/BasicDetails/BasicDetailsTitle.styles.ts


/* harmony default export */ var BasicDetailsTitle_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        icon: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5],
            marginRight: 6
        },
        xxsGapGroup: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            gap: 10
        }),
        features: (0,_define_property/* default */.Z)({
            display: "inline-flex",
            alignItems: "center",
            margin: 0,
            marginRight: 20,
            textAlign: "left",
            fontSize: 16,
            fontWeight: 300
        }, theme.fn.smallerThan("md"), {
            marginRight: 0
        }),
        textHidden: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            display: "none"
        }),
        textNumber: {
            marginRight: 4
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/components/BasicDetails/BasicDetailsTitle.tsx







var BasicDetailsTitle = function(param) {
    var details = param.details, settings = param.settings;
    var classes = BasicDetailsTitle_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    // TODO: Separate the label from number so we can do hidden xs for the label here
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        className: classes.xxsGapGroup,
        position: "left",
        mb: 20,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                align: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: classes.features,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconBed */.rqh, {
                            className: classes.icon,
                            size: 30,
                            stroke: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textNumber,
                            children: details === null || details === void 0 ? void 0 : details.bed_rooms
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textHidden,
                            children: (0,dxb_utils/* formatTitle */.Ui)(details === null || details === void 0 ? void 0 : details.bed_rooms, "Bedroom")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                align: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: classes.features,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconBath */.EfN, {
                            className: classes.icon,
                            size: 26,
                            stroke: 1.1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textNumber,
                            children: details === null || details === void 0 ? void 0 : details.bath_rooms
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textHidden,
                            children: (0,dxb_utils/* formatTitle */.Ui)(details === null || details === void 0 ? void 0 : details.bath_rooms, "Bathroom")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                align: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: classes.features,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconHotelService */.dO, {
                            className: classes.icon,
                            size: 26,
                            stroke: 1.1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textNumber,
                            children: details === null || details === void 0 ? void 0 : details.max_occupancy
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textHidden,
                            children: (0,dxb_utils/* formatTitle */.Ui)(details === null || details === void 0 ? void 0 : details.max_occupancy, "Guest")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                align: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: classes.features,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconRuler */.CBt, {
                            className: classes.icon,
                            size: 26,
                            stroke: 1.1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textNumber,
                            children: details === null || details === void 0 ? void 0 : details.size
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "m\xb2"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                align: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    className: classes.features,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMoonStars */.zG9, {
                            className: classes.icon,
                            size: 26,
                            stroke: 1.1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textNumber,
                            children: settings === null || settings === void 0 ? void 0 : settings.minimumNights
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.textHidden,
                            children: (0,dxb_utils/* formatTitleNoS */.nA)(settings === null || settings === void 0 ? void 0 : settings.minimumNights, "Nights Minimum")
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/VideoSection/VideoSection.styles.ts

/* harmony default export */ var VideoSection_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        videoPlayer: {
            borderRadius: theme.radius.xs,
            overflow: "hidden"
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/VideoSection/VideoSection.tsx







var VideoSection = function() {
    var ref, ref1, ref2;
    var classes = VideoSection_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    var url = (ref1 = propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref = propertyDetailsData.images) === null || ref === void 0 ? void 0 : ref.filter(function(img) {
        return img.type === "video" && img;
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.src;
    return isMounted && propertyDetailsData !== null && (propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref2 = propertyDetailsData.images) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSection, {
        heading: "Video tour of the property",
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
            className: classes.videoPlayer,
            url: url || "https://www.youtube.com/watch?v=8nbcdqOaWvk",
            playing: false,
            loop: false,
            light: false,
            controls: true,
            muted: true,
            width: "100%",
            height: "377px"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/DescriptionSection.tsx






var DescriptionSection = function(param) {
    var description = param.description;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSection, {
        // className={} to control content div only
        // change heading styling in the component itself.
        heading: "About this property",
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            size: 12,
            align: "justify",
            children: (0,html_react_parser/* default */.ZP)(description || "_")
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(8949);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Spoiler/Spoiler.js + 4 modules
var Spoiler = __webpack_require__(14);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/core/components/common/CList.tsx






// WE CAN HAVE SOME SANE DEFAULTS FOR THIS
var CList = function(props) {
    var children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: children
    }));
};

// EXTERNAL MODULE: ./src/core/utils/data-utils.ts
var data_utils = __webpack_require__(63002);
;// CONCATENATED MODULE: ./src/core/components/common/CIcon.tsx



var CIcon = function(param) {
    var dark = param.dark, light = param.light;
    var colorScheme = (0,MantineProvider/* useMantineTheme */.rZ)().colorScheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: colorScheme === "dark" ? dark : light
    });
};

// EXTERNAL MODULE: ./src/core/components/common/CImage.tsx
var CImage = __webpack_require__(83480);
;// CONCATENATED MODULE: ./src/features/property-details/components/Amenities/AmenitiesList.styles.ts

/* harmony default export */ var AmenitiesList_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        amenitiesList: {
            borderRadius: theme.radius.xs,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        },
        amenitiesSpoiler: {
            ".mantine-Spoiler-control": {
                textTransform: "uppercase",
                fontSize: 12,
                width: "100%",
                marginTop: 20,
                borderStyle: "dashed",
                borderWidth: 1,
                borderRadius: theme.radius.xs,
                color: theme.colorScheme === "light" ? theme.colors.dark[6] : theme.white,
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
                paddingTop: 10,
                paddingBottom: 10,
                ":hover": {
                    textDecoration: "none"
                }
            }
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/components/Amenities/AmenitiesList.tsx









/**
 // ICON FILE NAMES SHOULD LOOK LIKE THIS - snake_case_dark.svg
 // iconDark: '/icons/towels-bed-sheets-dark.svg',
 // iconLight: '/icons/towels-bed-sheets-light.svg',

 // EXCEPT THIS ONE :D
 // soundsystem - write its name as soundsystem_dark.svg
 */ var AmenitiesList = function(param) {
    var amenities = param.amenities;
    var classes = AmenitiesList_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var _amenities = amenities || [];
    // VISIBLE AMENITIES
    var amenitiesItem = _amenities.map(function(amenity) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
            p: 10,
            mt: 12,
            className: classes.amenitiesList,
            // WE CAN SHOW ICONS - IF WE HAVE ALL OF THEM AT ONE PLACE.
            // AS IT WILL REQUIRE SOME LOGICAL WORK TO FIND THE ICON
            // BASED ON AMENITY NAME.
            icon: // <IconStar size={16} color="orange" radius="sm"/>
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CIcon, {
                dark: /*#__PURE__*/ (0,jsx_runtime.jsx)(CImage/* CImage */.D, {
                    src: "/icons/amenities/".concat((0,data_utils/* convertStrToSnakeCase */.WJ)(amenity), "-dark.svg"),
                    alt: (0,data_utils/* convertStrToSnakeCase */.WJ)(amenity),
                    width: 40,
                    height: 40
                }),
                light: /*#__PURE__*/ (0,jsx_runtime.jsx)(CImage/* CImage */.D, {
                    src: "/icons/amenities/".concat((0,data_utils/* convertStrToSnakeCase */.WJ)(amenity), "-light.svg"),
                    alt: (0,data_utils/* convertStrToSnakeCase */.WJ)(amenity),
                    width: 40,
                    height: 40
                })
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                align: "center",
                size: 16,
                children: amenity
            })
        }, amenity);
    });
    // HIDDEN AMENITIES
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spoiler/* Spoiler */.o, {
        className: classes.amenitiesSpoiler,
        maxHeight: 80,
        showLabel: "Show more",
        hideLabel: "Hide",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CList, {
            spacing: "sm",
            size: "sm",
            center: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                cols: 2,
                spacing: "sm",
                breakpoints: [
                    {
                        maxWidth: "sm",
                        cols: 1
                    }
                ],
                children: amenitiesItem
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/LocationDescriptionSection.tsx







var LocationDescriptionSection = function(param) {
    var location = param.location;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSection, {
        // className={} to control content div only
        // change heading styling in the component itself.
        heading: "Discover ".concat((0,dxb_utils/* mapLocationDescLabelText */.dr)(location.address) || "_"),
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            size: 12,
            align: "justify",
            children: (0,html_react_parser/* default */.ZP)(location.description || "_")
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-map-gl/dist/esm/index.js + 21 modules
var esm = __webpack_require__(61108);
;// CONCATENATED MODULE: ./src/core/components/common/Maps/MapBox/MapMarker.tsx


// OLD IMPL
/*const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`

const pinStyle = {
    fill: '#d00',
    stroke: 'none',
    transform: 'translate(-50%,-100%)'
}*/ var MapMarker = function(props) {
    var _width = props.width, width = _width === void 0 ? "20" : _width, _height = props.height, height = _height === void 0 ? "48" : _height;
    return(/*<svg height={size} viewBox="0 0 24 24" style={pinStyle}>
            <path d={ICON}/>
        </svg>*/ /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        id: "marker",
        "data-name": "marker",
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 20 48",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "mapbox-marker-icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    id: "icon",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                            id: "shadow",
                            cx: "10",
                            cy: "27",
                            rx: "9",
                            ry: "5",
                            fill: "#c4c4c4",
                            opacity: "0.3",
                            style: {
                                isolation: "isolate"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            id: "mask",
                            opacity: "0.3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                id: "group",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "shadow-2",
                                    "data-name": "shadow",
                                    fill: "#bfbfbf",
                                    d: "M10,32c5,0,9-2.2,9-5s-4-5-9-5-9,2.2-9,5S5,32,10,32Z",
                                    fillRule: "evenodd"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "color",
                            fill: "#f79640",
                            stroke: "#ba7334",
                            strokeWidth: "0.5",
                            d: "M19.25,10.4a13.0663,13.0663,0,0,1-1.4607,5.2235,41.5281,41.5281,0,0,1-3.2459,5.5483c-1.1829,1.7369-2.3662,3.2784-3.2541,4.3859-.4438.5536-.8135.9984-1.0721,1.3046-.0844.1-.157.1852-.2164.2545-.06-.07-.1325-.1564-.2173-.2578-.2587-.3088-.6284-.7571-1.0723-1.3147-.8879-1.1154-2.0714-2.6664-3.2543-4.41a42.2677,42.2677,0,0,1-3.2463-5.5535A12.978,12.978,0,0,1,.75,10.4,9.4659,9.4659,0,0,1,10,.75,9.4659,9.4659,0,0,1,19.25,10.4Z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "circle",
                            fill: "#fff",
                            stroke: "#ba7334",
                            strokeWidth: "0.5",
                            d: "M13.55,10A3.55,3.55,0,1,1,10,6.45,3.5484,3.5484,0,0,1,13.55,10Z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: width,
                height: height,
                fill: "none"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/react-virtualized-auto-sizer/dist/react-virtualized-auto-sizer.esm.js
var react_virtualized_auto_sizer_esm = __webpack_require__(39142);
// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.css
var mapbox_gl = __webpack_require__(81634);
;// CONCATENATED MODULE: ./src/core/components/common/Maps/MapBox/MBMap.tsx









var defaultSettings = {
    scrollZoom: false,
    boxZoom: false,
    dragRotate: false,
    dragPan: false,
    keyboard: false,
    doubleClickZoom: false,
    touchZoomRotate: false,
    touchPitch: false,
    minZoom: 0,
    maxZoom: 18,
    minPitch: 0,
    maxPitch: 0
};
var MBMap = function(param) {
    var _key = param._key, _center = param._center, _zoom = param._zoom, layer = param.layer, cssStyle = param.cssStyle, _mapSettings = param._mapSettings;
    var mapSettings = _mapSettings || defaultSettings;
    var ref = (0,react.useState)({
        lat: _center.lat,
        long: _center.long
    }), latLong = ref[0], setLatLong = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState("auto"), 2), containerWidth = ref1[0], setContainerWidth = ref1[1];
    var mapRef = react.useRef();
    /*const toggleWidth = React.useCallback(
        () => setContainerWidth((w) => (w === '100vw' ? '50vw' : '100vw')),
        []
    );*/ var onResize = react.useCallback(function() {
        if (mapRef.current) {
            // @ts-expect-error
            setTimeout(function() {
                return mapRef.current.resize();
            }, 0);
        }
        return null;
    }, []);
    return(/*<Map
            reuseMaps={true}
            initialViewState={{
                longitude: latLong.long,
                latitude: latLong.lat,
                zoom: _zoom,
                bearing: 360,
                pitch: 180,
            }}
            {...mapSettings}
            mapStyle={`mapbox://styles/mapbox/${layer}`}
            mapboxAccessToken={_key}
            style={cssStyle}
        >

            {
                <GeolocateControl positionOptions={{ enableHighAccuracy: true }}
                               trackUserLocation
                               showUserLocation
                               position="top-left"/>
            }
            {/!*<FullscreenControl position="top-left"/>*!/}
            {/!*<NavigationControl position="top-left"/>*!/}
            {/!*<ScaleControl/>*!/}

            <Marker
                latitude={latLong.lat}
                longitude={latLong.long}
                anchor="bottom"
            >
                <MapMarker/>
            </Marker>

            <Marker longitude={latLong.long} latitude={latLong.lat}>
                <div style={{ color: 'red' }}>I am here</div>
            </Marker>

        </Map>*/ // NEW
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            width: containerWidth,
            height: "350px",
            marginBottom: "0",
            borderRadius: 6,
            transition: "width 1s"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_virtualized_auto_sizer_esm/* default */.ZP, {
                children: onResize
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                initialViewState: {
                    longitude: latLong.long,
                    latitude: latLong.lat,
                    zoom: _zoom,
                    bearing: 360,
                    pitch: 180
                }
            }, mapSettings), {
                mapStyle: "mapbox://styles/mapbox/".concat(layer),
                mapboxAccessToken: _key,
                // style={cssStyle}
                style: {
                    width: "auto",
                    height: "100%"
                },
                ref: mapRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                    latitude: latLong.lat,
                    longitude: latLong.long,
                    offset: [
                        20,
                        50
                    ],
                    anchor: "bottom",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapMarker, {})
                })
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/MapSection/MapSection.styles.ts


/* harmony default export */ var MapSection_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        progress: {
            textAlign: "center"
        },
        propertyDetailsLanding: {
            margin: "0 auto",
            maxWidth: theme.other.maxWidth
        },
        h2: (0,_define_property/* default */.Z)({
            letterSpacing: 0.6,
            color: theme.colorScheme === "dark" ? theme.colors.gray[5] : theme.colors.dark[4]
        }, theme.fn.smallerThan("sm"), {
            fontSize: 12
        }),
        titleLocation: (0,_define_property/* default */.Z)({
            display: "inline-flex",
            gap: theme.spacing.xs,
            flexWrap: "nowrap"
        }, theme.fn.smallerThan("sm"), {
            // fontSize: 14,
            // height: 23,
            // alignItems: 'flex-start',
            // overflow: 'hidden',
            flexWrap: "nowrap"
        }),
        locationIcon: {
            height: 24,
            minWidth: 24
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/MapSection/MapSection.tsx












/*interface Props {
    location: Location;
}*/ var MapSection = function() {
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    // const { isDark } = useDxbTheme()
    var data = (0,graphql/* useGetServiceKeysQuery */.z5)({
        fetchPolicy: "cache-and-network"
    }).data;
    var ref = (0,react.useState)(null), mapBoxApiKey = ref[0], setMapBoxApiKey = ref[1];
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var classes = MapSection_styles().classes;
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.getServiceKeys) {
            var ref;
            var key = data === null || data === void 0 ? void 0 : (ref = data.getServiceKeys) === null || ref === void 0 ? void 0 : ref.filter(function(_key) {
                return _key.name === "MAPBOX_ACCESS_TOKEN" && _key.value;
            })[0].value;
            setMapBoxApiKey(key);
        // console.log(key, 'key')
        // console.log(mapBoxApiKey, 'mapBoxApiKey')
        // console.log(location.latitude, location.longitude, location.street)
        }
    }, [
        data
    ]);
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSection, {
        heading: "Where you'll be staying",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    mt: -44,
                    mb: 30,
                    className: classes.titleLocation,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMap2 */.DZw, {
                            className: classes.locationIcon,
                            stroke: 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            lineClamp: 1,
                            className: classes.h2,
                            order: 2,
                            children: (0,dxb_utils/* getAddressText */.ol)(propertyDetailsData.location)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientOnly/* ClientOnly */.q, {
                    children: mapBoxApiKey && mapBoxApiKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MBMap, {
                        _key: mapBoxApiKey,
                        _center: {
                            lat: propertyDetailsData.location.latitude,
                            long: propertyDetailsData.location.longitude
                        },
                        _zoom: 12,
                        // cssStyle={{ width: 'auto', height: '350px', marginBottom: '0', borderRadius: 6 }}
                        // layer={isDark ? 'dark-v10' : 'light-v10'}
                        layer: "streets-v11"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                        mt: 30,
                        mb: 30,
                        className: classes.progress,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                            color: "#f39c12",
                            variant: "dots",
                            size: "sm"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/core/components/common/LinkButton.tsx
var LinkButton = __webpack_require__(48804);
;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/ThingsToKnowSection/ThingsToKnowSection.styles.ts


/* harmony default export */ var ThingsToKnowSection_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        h3: {
            letterSpacing: 0.6,
            color: theme.colorScheme === "dark" ? theme.colors.gray[5] : theme.colors.dark[4]
        },
        links: {
            "a": {
                fontSize: 12,
                fontWeight: 400,
                color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9]
            },
            "a:hover": {
                color: theme.colors.orange[5],
                textDecoration: "none"
            }
        },
        thingsGridCol: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            marginTop: 20
        })
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/containers/sections/ThingsToKnowSection/ThingsToKnowSection.tsx









var ThingsToKnowSection = function() {
    var classes = ThingsToKnowSection_styles().classes;
    var isLight = (0,use_dxb_theme/* default */.Z)().isLight;
    var listHouseRulesData = [
        {
            label: "Check-in: 3:00 PM.",
            icon: "".concat(isLight ? "/icons/clock-light.svg" : "/icons/clock-dark.svg")
        },
        {
            label: "Check-out: 12:00 PM.",
            icon: "".concat(isLight ? "/icons/clock-light.svg" : "/icons/clock-dark.svg")
        },
        {
            label: "Self check-in.",
            icon: "".concat(isLight ? "/icons/key-light.svg" : "/icons/key-dark.svg")
        },
        {
            label: "No smoking.",
            icon: "".concat(isLight ? "/icons/no-smoking-light.svg" : "/icons/no-smoking-dark.svg")
        },
        {
            label: "Pets are not allowed.",
            icon: "".concat(isLight ? "/icons/no-pets-light.svg" : "/icons/no-pets-dark.svg")
        }
    ];
    var listHouseRulesItems = listHouseRulesData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            mb: 14,
            mt: 14,
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CImage/* CImage */.D, {
                    width: 18,
                    height: 18,
                    src: item.icon,
                    alt: item.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    ml: 4,
                    size: 12,
                    children: item.label
                })
            ]
        }, item.label);
    });
    var listHealthSafetyData = [
        {
            label: "Committed to enhanced cleaning process.",
            icon: "".concat(isLight ? "/icons/verified-light.svg" : "/icons/verified-dark.svg")
        },
        {
            label: "Sanitized before every check in.",
            icon: "".concat(isLight ? "/icons/sanitized-light.svg" : "/icons/sanitized-dark.svg")
        },
        {
            label: "Emergency first-aid kit.",
            icon: "".concat(isLight ? "/icons/first-aid-light.svg" : "/icons/first-aid-dark.svg")
        },
        {
            label: "Smoke alarm.",
            icon: "".concat(isLight ? "/icons/smoke-alarm-light.svg" : "/icons/smoke-alarm-dark.svg")
        }
    ];
    var listHealthSafetyItems = listHealthSafetyData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            mb: 14,
            mt: 14,
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CImage/* CImage */.D, {
                    width: 18,
                    height: 18,
                    src: item.icon,
                    alt: item.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    ml: 4,
                    size: 12,
                    children: item.label
                })
            ]
        }, item.label);
    });
    var listPoliciesData = [
        {
            label: "Terms and Conditions",
            route: AppRoutes/* AppRoutes.TERMS */.$w.TERMS,
            icon: "".concat(isLight ? "/icons/link-right-light.svg" : "/icons/link-right-dark.svg")
        },
        {
            label: "House and refund policies",
            route: AppRoutes/* AppRoutes.POLICIES */.$w.POLICIES,
            icon: "".concat(isLight ? "/icons/link-right-light.svg" : "/icons/link-right-dark.svg")
        },
        {
            label: "Contact us",
            route: AppRoutes/* AppRoutes.CONTACT */.$w.CONTACT,
            icon: "".concat(isLight ? "/icons/link-right-light.svg" : "/icons/link-right-dark.svg")
        }
    ];
    var listPoliciesItems = listPoliciesData.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            className: classes.links,
            mb: 14,
            mt: 14,
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CImage/* CImage */.D, {
                    width: 18,
                    height: 18,
                    src: item.icon,
                    alt: item.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                    title: item.label,
                    route: item.route
                })
            ]
        }, item.label);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CSection, {
        // className={} to control content div only
        // change heading styling in the component itself.
        heading: "Things you need to know",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                    sm: 3,
                    md: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            mb: 20,
                            className: classes.h3,
                            order: 3,
                            children: "House Rules"
                        }),
                        listHouseRulesItems
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                    className: classes.thingsGridCol,
                    sm: 5,
                    md: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            mb: 20,
                            className: classes.h3,
                            order: 3,
                            children: "Health & Safety"
                        }),
                        listHealthSafetyItems
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                    className: classes.thingsGridCol,
                    sm: 4,
                    md: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            mb: 20,
                            className: classes.h3,
                            order: 3,
                            children: "Detailed Policies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: 14,
                            mb: 20,
                            children: "If you have any questions feel free to contact us."
                        }),
                        listPoliciesItems
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/property-details/containers/PropertyDetailsLanding.styles.ts


/* harmony default export */ var PropertyDetailsLanding_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    var _obj;
    return {
        propertyDetailsLanding: {
            margin: "0 auto",
            maxWidth: theme.other.maxWidth
        },
        propertyDetailsGrid: {
            flexDirection: "row-reverse"
        },
        propertyDetailsDiv: (0,_define_property/* default */.Z)({
            width: "58%",
            marginTop: 20
        }, theme.fn.smallerThan("md"), {
            width: "100%"
        }),
        propertyBookingDiv: (_obj = {
            width: "38%",
            marginTop: 20,
            marginBottom: 20
        }, (0,_define_property/* default */.Z)(_obj, theme.fn.largerThan("md"), {
            position: "sticky",
            top: 20
        }), (0,_define_property/* default */.Z)(_obj, theme.fn.smallerThan("md"), {
            width: "100%"
        }), _obj)
    };
}));

;// CONCATENATED MODULE: ./src/features/property-details/containers/PropertyDetailsLanding.tsx





















var PropertyDetailsLanding = function() {
    var ref, ref1;
    var mountLock = (0,react.useRef)(true);
    var classes = PropertyDetailsLanding_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    var setLastPage = (0,use_app_data/* default */.Z)().setLastPage;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setLastPage(router.asPath);
        if (mountLock.current) {
            mountLock.current = false;
        }
    }, []);
    return isMounted && propertyDetailsData !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: classes.propertyDetailsLanding,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTitle, {
                        name: propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.name,
                        address: (0,dxb_utils/* getAddressText */.ol)(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.location)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicDetailsTitle, {
                        details: propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.details,
                        settings: propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.settings
                    })
                ]
            }, "HEADING"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: (propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref = propertyDetailsData.images) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsGallery, {})
            }, "GALLERY"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 0,
                    position: "apart",
                    align: "start",
                    className: classes.propertyDetailsGrid,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.propertyBookingDiv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientOnly/* ClientOnly */.q, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingCard, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.propertyDetailsDiv,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSection, {
                                    description: propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CSection, {
                                    heading: "What this property offers",
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(AmenitiesList, {
                                        amenities: propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref1 = propertyDetailsData.details) === null || ref1 === void 0 ? void 0 : ref1.amenities
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationDescriptionSection, {
                                    location: propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.location
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSection, {})
                            ]
                        })
                    ]
                })
            }, "DETAILS"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapSection, {})
            }, "MAP"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThingsToKnowSection, {})
            })
        ]
    });
} //TODO:: LOGOUT - BOOKING FLOW TESTS
;

// EXTERNAL MODULE: ./src/core/layouts/AppLayout.tsx + 27 modules
var AppLayout = __webpack_require__(74797);
// EXTERNAL MODULE: ./src/core/components/common/AppHead.tsx
var AppHead = __webpack_require__(46055);
// EXTERNAL MODULE: ./src/core/constants/app-meta-data.ts + 1 modules
var app_meta_data = __webpack_require__(80311);
;// CONCATENATED MODULE: ./src/core/seo/PropertyDetailsSeoUtil.ts



var getPropertyDetailsSeoData = function(propertyDetailsData) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var beds = "".concat(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref = propertyDetailsData.details) === null || ref === void 0 ? void 0 : ref.bed_rooms, " ").concat((0,dxb_utils/* formatTitle */.Ui)(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref1 = propertyDetailsData.details) === null || ref1 === void 0 ? void 0 : ref1.bed_rooms, "Bed"));
    var baths = "".concat(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.details.bath_rooms, " ").concat((0,dxb_utils/* formatTitle */.Ui)(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref2 = propertyDetailsData.details) === null || ref2 === void 0 ? void 0 : ref2.bath_rooms, "Bathroom"));
    var guests = "".concat(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : propertyDetailsData.details.max_occupancy, " ").concat((0,dxb_utils/* formatTitle */.Ui)(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref3 = propertyDetailsData.details) === null || ref3 === void 0 ? void 0 : ref3.max_occupancy, "Guest"));
    var address = (0,dxb_utils/* mapLocationStreetLabelText */.Ud)(propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref4 = propertyDetailsData.location) === null || ref4 === void 0 ? void 0 : ref4.address) || "_";
    var seoDescription = (propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref5 = propertyDetailsData.description) === null || ref5 === void 0 ? void 0 : ref5.substring(0, 150)) || "_";
    var seoTitle = " ".concat(beds, " | ").concat(baths, " | ").concat(guests, " | Available In ").concat(address);
    var propImages = propertyDetailsData === null || propertyDetailsData === void 0 ? void 0 : (ref6 = propertyDetailsData.images) === null || ref6 === void 0 ? void 0 : ref6.filter(function(img) {
        return img.type === "image" && img;
    });
    var seoImage = [];
    propImages === null || propImages === void 0 ? void 0 : propImages.forEach(function(img) {
        // img.src
        seoImage.push({
            url: "".concat(network_utils/* S3_PROPERTY_BUCKET_URL */.oe, "/").concat(img.src),
            alt: img.alt
        });
    });
    return {
        title: seoTitle,
        description: seoDescription,
        images: seoImage,
        locale: app_meta_data/* AppMetaData.APP_LOCALE */.G.APP_LOCALE,
        siteName: app_meta_data/* AppMetaData.APP_NAME */.G.APP_NAME
    };
};

;// CONCATENATED MODULE: ./src/pages/properties/[slug].tsx










var PropertyDetailsPage = function(param) {
    var time = param.time, propertyDetailsData = param.propertyDetailsData;
    var setPropertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().setPropertyDetailsData;
    var asPath = (0,next_router.useRouter)().asPath;
    var seoUrl = (0,url_join/* default */.Z)(app_meta_data/* AppMetaData.WEB_URL */.G.WEB_URL || "", asPath);
    (0,react.useEffect)(function() {
        setPropertyDetailsData(JSON.stringify(propertyDetailsData));
    }, [
        propertyDetailsData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHead/* default */.Z, {
                title: getPropertyDetailsSeoData(propertyDetailsData).title,
                description: "".concat(getPropertyDetailsSeoData(propertyDetailsData).description.replace(/(<([^>]+)>)/ig, "")),
                openGraph: {
                    url: seoUrl,
                    title: getPropertyDetailsSeoData(propertyDetailsData).title,
                    description: getPropertyDetailsSeoData(propertyDetailsData).description.replace(/(<([^>]+)>)/ig, ""),
                    locale: getPropertyDetailsSeoData(propertyDetailsData).locale,
                    siteName: getPropertyDetailsSeoData(propertyDetailsData).siteName,
                    images: getPropertyDetailsSeoData(propertyDetailsData).images
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyDetailsLanding, {})
        ]
    });
};
// @ts-expect-error
PropertyDetailsPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        requireAuth: false,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PropertyDetailsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,662,930,151,810,985,521,360,207,774,888,377], function() { return __webpack_exec__(17599); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);